import type { components, paths } from "@/api/schema.ts";
import { useMutation, useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { HTTPError } from "ky";
import { api } from "@/api/ky.ts";
import { getApiUrl } from "@/api/utils.ts";

export const PAYMENT_PROVIDERS_KEY = "paymentProviders";
type PaymentProviderParams = paths["/merchants/{merchantId}/payment-providers"]["get"]["parameters"]["path"];
type PaymentProviderQueryParams = paths["/merchants/{merchantId}/payment-providers"]["get"]["parameters"]["query"];
export type PaymentProviderResponse = components["schemas"]["PaymentProviders"];

export function usePaymentProviderQuery(
  searchParams: PaymentProviderQueryParams,
  params: PaymentProviderParams,
  options?: Omit<UseQueryOptions<PaymentProviderResponse, HTTPError>, "queryFn" | "queryKey">,
) {
  return useQuery<PaymentProviderResponse, HTTPError>({
    queryKey: [PAYMENT_PROVIDERS_KEY, params, searchParams],
    queryFn: () => api.get(getApiUrl("/merchants/{merchantId}/payment-providers", params), { searchParams }).json(),
    ...options,
  });
}

export const ALL_PAYMENT_PROVIDERS_KEY = "allPaymentProviders";

export function useAllPaymentProvidersQuery(
  options?: Omit<UseQueryOptions<PaymentProviderResponse, HTTPError>, "queryFn" | "queryKey">,
) {
  return useQuery<PaymentProviderResponse, HTTPError>({
    queryKey: [ALL_PAYMENT_PROVIDERS_KEY],
    queryFn: () => api.get(getApiUrl("/payment-provider")).json(),
    ...options,
  });
}

type PaymentProviderStatusParams =
  paths["/merchants/{merchantId}/payment-providers/status"]["put"]["parameters"]["path"];
type PaymentProviderStatusInput =
  components["requestBodies"]["EnablingPaymentProviders"]["content"]["application/json"];

export function usePaymentProvidersStatusMutation(params: PaymentProviderStatusParams) {
  return useMutation<undefined, HTTPError, PaymentProviderStatusInput>({
    mutationFn: (json) =>
      api.put(getApiUrl("/merchants/{merchantId}/payment-providers/status", params), { json }).json(),
  });
}
